export default __webpack_public_path__ + "static/media/Angle_Input.d9dda651.svg";